<template>
  <v-flex xs12 class="telefonos">
    <v-layout row wrap>
      <v-flex xs12>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <v-label for="telefonos" class="mt-3" :class="errorMessages ? 'error--text' : ''" v-html="htmlLabelTelefonos"></v-label>        
        <v-input v-if="errorMessages" class="mt-0" :error-messages="errorMessages" />
      </v-flex>
      <v-flex v-if="talento.telefonos && talento.telefonos != ''" xs12 class="d-flex align-center'">
        <v-chip-group v-model="telefonos.selection" column active-class="primary--text">
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <draggable v-model="talento.telefonos" @start="dragStart" @end="dragEnd">
            <v-chip v-for="(item, index) in talento.telefonos" :key="index" small close value draggable @click:close="remove(item)" @dblclick="(counter += 1), edit(item)">
              ({{ item.tipo }}) {{ item.telefono }}
            </v-chip>
          </draggable>
        </v-chip-group>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs5>
            <v-text-field
              :key="refreshkey"
              v-model="$v.telefonos.telefono.$model"
              v-mask="'+##############'"
              maxlength="15"
              outlined
              filled
              dense
              :disabled="disabled"
              :error-messages="getFirstErrorDescription($v.telefonos.telefono) || errorTelefonoDuplicado"
              :label="$t('view.talento.form.telefonos.th2')"
              prepend-inner-icon="mdi mdi-phone"
              :loading="telefonoChecking"
              :return-masked-value="true"
              @keypress="errorTelefonoDuplicado = ''" />
          </v-flex>
          <v-flex xs5>
            <v-autocomplete
              v-model.trim="$v.telefonos.tipo.$model"
              :label="$t('view.talento.form.tipoTelefono.label')"
              :error-messages="getFirstErrorDescription($v.telefonos.tipo)"
              :items="view.elem.select.tipoTelefono.filteredList"
              :disabled="disabled"
              item-value="code"
              item-text="name"
              clearable
              outlined
              filled
              dense
              :no-data-text="$t('view.commons.nodata')"
              @input="search = ''" />
          </v-flex>
          <v-flex xs2 class="pt-3 d-flex justify-center">
            <v-btn
              fab
              x-small
              dark
              :color="update ? 'secondary' : 'primary'"
              class="btn_tippy addtelefonos"
              elevation="0"
              :title="update ? $t('view.commons.edit') : $t('view.commons.add')"
              @click="add()">
              <v-icon x-small>{{ update ? "fa-pen" : "fa-plus" }}</v-icon>
            </v-btn>
            <v-btn v-show="update" fab x-small dark color="grey" class="btn_tippy addtelefonos ml-2" elevation="0" :title="$t('view.commons.cancel')" @click="clear()">
              <v-icon x-small>fa-eraser</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import Draggable from "vuedraggable";
import { required, minLength } from "vuelidate/lib/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { TLT_TIPOTELEFONO_SELECT, TLT_TIPOTELEFONO_NUM_CELU } from "@/constants/operativos";
import tippy from "tippy.js";
import talentoAPI from "@/services/talento";

const select = {
  tipoTelefono: {
    filteredList: TLT_TIPOTELEFONO_SELECT
    , disabled: false
  }
};

export default {
  name: "TalentoTelefonos"
  , components: { Draggable }
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
    , disabled: {
      default: false
      , type: Boolean
    }
    , errorMessages: {
      default: undefined
      , type: String
    }
  }
  , data() {
    return {
      counter: 0
      , refreshkey: 0
      , update: false
      , oldnum: ""
      , telefonoChecking: false
      , errorTelefonoDuplicado: ""
      , telefonos: {
        selection: null
        , current: null
        , telefono: this.talento.pais ? this.talento.pais.lada : ""
        , tipo: TLT_TIPOTELEFONO_NUM_CELU
      }
      , view: { elem: { select } }
    };
  }
  , computed: {
    htmlLabelTelefonos() {
      return this.$t("view.talento.form.telefonos.label");
    }
  }
  , created() {
    this.$v.telefonos.$reset();
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , updated() {
    this.$v.telefonos.$reset();
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async add() {
      if (this.isAllValid(this.$v.telefonos)) {
        const telefonoNum = this.telefonos.telefono.replace(/\D/g, "");

        if (this.talento.telefonos.find((value) => value.num == (this.update ? this.oldnum : telefonoNum)) == null) {
          if (await this.checkTelefonoNoDuplicado(this.telefonos.telefono)) {
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos.push({
              telefono: this.telefonos.telefono
              , tipo: this.telefonos.tipo
              , code: this.telefonos.telefono
              , name: this.telefonos.tipo
              , num: telefonoNum
            });
            this.clear();
          }
        } else if (this.update) {
          const index = this.talento && this.talento.telefonos ? this.talento.telefonos.findIndex((obj) => obj.num == this.oldnum) : null;
          if (index != null) {
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos[index].telefono = this.telefonos.telefono;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos[index].tipo = this.telefonos.tipo;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos[index].code = this.telefonos.telefono;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos[index].name = this.telefonos.tipo;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.telefonos[index].num = telefonoNum;
            this.clear();
          }
        } else {
          this.errorTelefonoDuplicado = this.$t("view.talento.errors.telefonoNoDuplicado.text");
        }
      }
    }
    , remove(item) {
      // eslint-disable-next-line vue/no-mutating-props
      this.talento.telefonos = this.talento.telefonos.filter((value) => value.telefono != item.telefono);
      this.clear();
      setTimeout(() => document.body.click(), 200);
    }
    , clear() {
      this.telefonos.telefono = this.talento.pais ? this.talento.pais.lada : "";
      this.telefonos.tipo = TLT_TIPOTELEFONO_NUM_CELU;
      this.errorTelefonoDuplicado = "";
      setTimeout(() => {
        this.telefonos.telefono = this.talento.pais ? this.talento.pais.lada : "";
        this.update = false;
        this.$v.telefonos.$reset();
      }, 100);
    }
    , dragStart() {
      if (this.talento.telefonos[this.telefonos.selection]) this.telefonos.current = this.talento.telefonos[this.selection].telefono;
      else this.telefonos.current = null;
    }
    , dragEnd() {
      let that = this;
      if (this.telefonos.current) {
        this.talento.telefonos.forEach((x, i) => {
          if (x.name === that.telefonos.current) that.telefonos.selection = i;
        });
      }
    }
    , async edit(item) {
      this.telefonos.telefono = item.telefono;
      this.telefonos.tipo = item.tipo;
      this.oldnum = item.num;
      this.update = true;
    }
    , setLada(lada) {
      this.telefonos.telefono = lada;
      this.refreshkey += 1;
    }
    , async checkTelefonoNoDuplicado(value) {
      const num = (value || "").replace(/\D/g, "");

      if (num.length === 0) return true;
      if (this.update && num === this.oldnum) return true;

      try {
        this.telefonoChecking = true;
        const response = await talentoAPI.existeTelefono({ telefonos: JSON.stringify([{ num }]), clave: this.talento.clave });
        const { data: { results: { existe } } } = response;
        if (existe) {
          this.errorTelefonoDuplicado = this.$t("view.talento.errors.telefonoNoDuplicado.text");
          return false;
        } else {
          return true;
        }
      } catch (error) {
        console.log(error);
        return false;
      } finally {
        this.telefonoChecking = false;
      }
    }
  }
  , validations: {
    telefonos: {
      telefono: {
        required
        , minLength: minLength(8)
      }
      , tipo: { required }
    }
  }
};
</script>

<style scoped>
.talento .telefonos .addtelefonos.v-size--x-small {
  width: 25px;
  height: 25px;
}
.talento .telefonos .whatsapp {
  height: 24px !important;
  width: 24px !important;
  margin-left: -12px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/talento/TalentoTelefonos.vue